<template>
  <div class="games">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page edit">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-12 cell">

          <bouton href="dashboard-caregiver" class-bt="return">Retour au carnet de bord</bouton>

          <title-page attrpage="Mon compte" baseline="">Editer et gérer mes informations</title-page>

          <p>Cette page vous permet de gérer vos informations.</p>
          <hr>
        </div>

          <div class="small-12 medium-4 cell">
            <div class="form ">
              <div :class="{error: errors.indexOf('firstname') !== -1}">
                <label for="prenom">Prénom* :</label>
                <input type="text" name="prenom" id="prenom" v-model="first_name" required />
              </div>
              <div :class="{error: errors.indexOf('lastname') !== -1}">
                <label for="nom">Nom de famille* :</label>
                <input type="text" name="nom" id="nom" v-model="last_name" required />
              </div>
              <div :class="{error: errors.indexOf('job') !== -1}">
                <label for="job">Profession :</label>
                <select name="job" id="job" v-model="job" required >
                  <option disabled value>--Sélectionnez votre profession--</option>
                  <option v-for="job,job_id of SoignantDB" :value="job_id" :key="job_id">{{ job.name }}</option>
                </select>
              </div>
              <div :class="{error: errors.indexOf('email') !== -1}">
                <label for="email">Email*</label>
                <input type="email" name="email" id="email" v-model="email" required />
              </div>
              <label for="phone">Téléphone</label>
              <input type="tel" name="phone" id="phone" v-model="phone" required />
            </div>
          </div>

          <!-- TODO Mettre la possibilité d'uploader une photo pour l'avatar -->
          <div class="small-12 medium-5 cell">
            <div class="edit-avatar">
              <caregiver-avatar :user="currentUser" />
              <button @click="clearAvatar" v-if="me.avatar" class="button btnPush">Revenir à l'avatar par défaut</button>
              <br>
              <br>
              <label for="file" class="button btnPush">Changer mon avatar</label>
              <input style="display: none" id="file" type="file" ref="file" @change="upload" />
              <br>
              <em>Format minimum de 400 x 400 px en jpeg</em>
            </div>
          </div>

          <div class="small-12 medium-3 cell">
            <ul class="nav-dashbord">
              <li><a @click="changeMyPassword"><i class="fas fa-lock"></i>Modifier mon mot de passe</a></li>
              <li><hr></li>
              <template v-if="deleting">
                <li><i class="fas fa-question"/>Êtes-vous sur de vouloir supprimer votre compte ?</li>
                <li class="deleted" style="text-align: center;float: left"><a @click="confirmDelete"><i class="fas fa-trash-alt" style="margin-right: 0"/><br>OUI,<br> je confirme</a></li>
                <li style="text-align: center;float: right"><a @click="cancelDelete"><i class="fas fa-meh-rolling-eyes" style="margin-right: 0"/><br>NON,<br> j'annule</a></li>
              </template>
              <li v-else class="deleted" @click="deleteMyAccount"><a><i class="fas fa-trash-alt"></i>Supprimer mon compte</a></li>
            </ul>
          </div>

          <div class="small-12 medium-12 center cell">
            <hr>
            <input class="button btnPush" name="submit" type="submit" value="Enregistrer les modifications" @click="send" @mouseover="verify"  />
          </div>

      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import CaregiverAvatar from '@/components/CaregiverAvatar'
  import { mapActions, mapState, mapGetters } from 'vuex'
  import { dateFromString } from '@/functions'
  import SoignantDB from '@/datas/soignants'

  export default {
    components: { TitlePage, Bouton, CaregiverAvatar },
    data() {
      let me = this.$store.state.me
      return {
        first_name: me.first_name,
        last_name: me.last_name,
        job: me.title,
        email: me.email,
        phone: me.phone,
        mail_appointment: me.notif_mail.indexOf('appointment') !== -1,
        sms_appointment: me.notif_sms.indexOf('appointment') !== -1,
        mail_community: me.notif_mail.indexOf('community') !== -1,
        sms_community: me.notif_sms.indexOf('community') !== -1,
        mail_autoeval: me.notif_mail.indexOf('autoeval') !== -1,
        sms_autoeval: me.notif_sms.indexOf('autoeval') !== -1,
        deleting: false,
        SoignantDB,
        errors: []
      }
    },
    computed: {
      ...mapState(['me']),
      ...mapGetters(['childName']),
      currentUser() {
        return this.$store.state.me
      }
    },
    methods: {
      ...mapActions(['updateMe', 'uploadAvatar', 'resetAvatar', 'sendResetPasswordInstructions', 'deleteMe', 'signout', 'addNotice']),
      verify (field) {
        this.errors = []
        if (!this.first_name) {
          this.errors.push("firstname")
        }
        if (!this.last_name) {
          this.errors.push("lastname")
        }
        if (!this.job) {
          this.errors.push("job")
        }
        if (!this.email) {
          this.errors.push("email")
        }
      },
      async send (e) {
        e.preventDefault();
        this.verify();
        if (this.errors.length > 0) {
          return false
        }

        let notif_mail = []
        if (this.mail_appointment)
          notif_mail.push('appointment')
        if (this.mail_community)
          notif_mail.push('community')
        if (this.mail_autoeval)
          notif_mail.push('autoeval')

        let notif_sms = []
        if (this.sms_appointment)
          notif_sms.push('appointment')
        if (this.sms_community)
          notif_sms.push('community')
        if (this.sms_autoeval)
          notif_sms.push('autoeval')

        try {
          let userCommit = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            phone: this.phone,
            title: this.job,
            notif_mail: JSON.stringify(notif_mail),
            notif_sms: JSON.stringify(notif_sms)
          }
          this.updateMe({ userCommit })
          this.addNotice({ message: `J'ai bien enregistré les informations avec succès.` })
          this.$router.push({name: 'dashboard'})
        } catch (ex) {
          console.log(ex)
        }
      },
      deleteMyAccount (e) {
        this.deleting = true;
      },
      cancelDelete (e) {
        this.deleting = false;
      },
      async confirmDelete (e) {
        await this.deleteMe()
        await this.signout()

        this.$router.push({name: 'home'})
      },
      changeMyPassword (e) {
        this.sendResetPasswordInstructions({email: this.me.email})
        this.addNotice({ message: `Un mail vous a été envoyé sur ${this.me.email} pour effectuer le changement de mot de passe.` })
        this.$router.push({name: 'dashboard'})
      },
      upload() {
        this.uploadAvatar(this.$refs.file.files[0])
      },
      clearAvatar() {
        this.resetAvatar()
      }
    }
  }
</script>
